const h5Config = {
  themeColor: '#dc750e',
  pageSize: 10,
};

export default h5Config;
